<template>
	<div class="list-view">
		<div class="list-head">
			<slot name="header"/>
		</div>
		<div class="item-wrap" v-for="item in sortedItems">
			<slot name="itemTemplate"
				  :items="sortedItems"
				  :item="item"
			/>
		</div>
	</div>
</template>

<script>
	export default {
		name: "List",
		props: {
			items: Array,
			sortAsc: Boolean,
			sortKey: String
		},
		computed: {
			sortedItems() {
				let sortedItems = this.items.sort((a, b) => {
					let nameA = a[this.sortKey] ? a[this.sortKey].toString().toUpperCase() : ""; // Groß-/Kleinschreibung ignorieren
					let nameB = b[this.sortKey] ? b[this.sortKey].toString().toUpperCase() : ""; // Groß-/Kleinschreibung ignorieren
					if (nameA < nameB) {
						return -1;
					}
					if (nameA > nameB) {
						return 1;
					}

					// Namen müssen gleich sein
					return 0;
				});
				if (!this.sortAsc) {
					return sortedItems.reverse()
				}
				return sortedItems
			}
		}
	}
</script>

<style lang="scss" scoped>
	$fa-font-path: "../../assets/fonts";
	$img-path: "../../assets/img";

	@import "~cssteudter-bootstrap-theme/scss/main";

	.list-view {
		.list-head {
			@extend .mb-2
		}

		.item-wrap {
			@extend .bg-light;
			@extend .mb-2;
			@extend .px-2
		}
	}
</style>
